import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  isAuthenticatingSelector,
  loginFailureSelector,
  authenticatedUserSelector,
  loginWithCredentialsAction,
  AuthenticationNgRxActions,
} from '@geekbears/gb-ngrx-auth-basic';
import { getFailureMessageRxOp } from '@geekbears/gb-ngrx-stack-base';
import { ModalService } from '@geekbears/ngx-gb-ui-kit';
import { Store } from '@ngrx/store';
import { isNil } from 'lodash-es';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { AppState } from '../../../../../core/application/store/app.state';
import { Actions, ofType } from '@ngrx/effects';
import { SessionService } from '../../../../../core/application/session.service';
@Component({
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {
  logInForm!: FormGroup;
  loading$!: Observable<boolean>;
  errorMessage$!: Observable<string | null>;
  displaError$!: Observable<boolean>;
  rememberMe: boolean = false;
  isDisabled: boolean = false;

  constructor(
    private builder: FormBuilder,
    public modals: ModalService,
    private store: Store<AppState>,
    private activatedRoute: ActivatedRoute,
    private actions$: Actions,
    private router: Router,
    private sessionService: SessionService
  ) {
    localStorage.removeItem('done');
  }

  ngOnInit(): void {
    this.loading$ = this.store.select(isAuthenticatingSelector).pipe(
      tap((value) => {
        if (value) this.isDisabled = true;
      })
    );
    this.store
      .select(authenticatedUserSelector)
      .pipe(
        tap((value) => {
          if (value) this.isDisabled = false;
        })
      )
      .subscribe();

    // // this.actions$.pipe(
    // //   ofType(AuthenticationNgRxActions.loginWithCredentialsSuccess),
    // //   tap(() => {
    // //     this.router.
    // //   })
    // // )

    this.displaError$ = this.store.select(loginFailureSelector).pipe(
      map((failure) => {
        return !isNil(failure);
      })
    );
    this.errorMessage$ = this.store.select(loginFailureSelector).pipe(
      getFailureMessageRxOp(),
      tap(() => {
        setTimeout(() => {
          this.isDisabled = false;
        }, 1500);
      })
    );
    this.logInForm = this.builder.group({
      email: [
        '',
        [
          Validators.required,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
        ],
      ],
      password: ['', [Validators.required]],
    });
    this.getParams();
  }

  get emailField(): FormControl {
    return this.logInForm.get('email') as FormControl;
  }

  get passwordField(): FormControl {
    return this.logInForm.get('password') as FormControl;
  }

  logInSubmit(): void {
    if (this.rememberMe) this.setRememberMeEmails(this.logInForm.value.email);
    //  If the form is invalid, exit early.
    if (this.logInForm.invalid || this.isDisabled == true) return;
    this.store.dispatch(
      loginWithCredentialsAction({
        email: this.logInForm.value.email,
        password: this.logInForm.value.password,
        deviceInfo: {
          id: this.generateDeviceId(),
          name: this.getDeviceName(),
          platform:'web'
        }
      } as any)
    );
  }

  private generateDeviceId(): string {
    // Generate or retrieve a unique device ID
    let deviceId = localStorage.getItem('deviceId');
    if (!deviceId) {
      deviceId = 'device-' + Math.random().toString(36).substring(2, 11);
      localStorage.setItem('deviceId', deviceId);
    }
    return deviceId;
  }

  private getDeviceName(): string {
    // Get browser/device name from user agent
    const userAgent = navigator.userAgent;
    if (userAgent.includes('Chrome')) return 'Chrome Browser';
    if (userAgent.includes('Safari')) return 'Safari Browser';
    if (userAgent.includes('Firefox')) return 'Firefox Browser';
    if (userAgent.includes('MSIE') || userAgent.includes('Trident')) return 'Internet Explorer';
    return 'Unknown Device';
  }

  getParams() {
    this.activatedRoute.queryParams
      .pipe(map((params) => params))
      .subscribe(async (params) => {
        // console.log(params, 'PARAMS');

        if (params['newUser'] === 'true') {
          this.sessionService.clearSession();
        }

        if (params['code']) {
          localStorage.setItem('confirmAccountToken', params['code']);
        }
        if (params['password']) {
          this.logInForm.patchValue({
            password: params['password'],
          });
        }
        if (params['email']) {
          localStorage.setItem('confirmAccountEmail', params['email']);
          let email = params['email'].replaceAll(' ', '+');
          this.logInForm.get('email')?.setValue(email);
        } else {
          let commonUserEmail: null | string =
            localStorage.getItem('s_common_user');
          if (commonUserEmail)
            this.logInForm.get('email')?.setValue(commonUserEmail);
        }
      })
      .unsubscribe();
  }

  setRememberMeEmails(email: string) {
    localStorage.setItem('s_common_user', email);
  }
  emailToLowercase(event: any) {
    this.logInForm
      .get('email')
      ?.setValue(event.target.value.toLocaleLowerCase());
  }
}
